import React from "react";
import { X } from "react-feather";
import "./styles.scss";

const OperationTypePickerModal = ({ onClose, onSelectStart }) => {
  return (
    <>
      <div className="modal picker-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <div className="modal-card-title">
              Escolha como iniciar a operação
            </div>
            <X
              data-testid="close-button"
              className="close-button"
              onClick={onClose}
            />
          </header>
          <section className="modal-card-body">
            <div className="picker-div">
              <button onClick={() => onSelectStart("car")}>
                Tenho os CARs e gostaria de inserir eles
              </button>
              <button onClick={() => onSelectStart("gleba")}>
                Não tenho os CARs e gostaria de detectar pelas glebas
              </button>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default OperationTypePickerModal;
